import React from 'react';
import styles from './listaNCM.module.scss';
import ListaNCMItem from '../listaNCMItem/listaNCMItem';
import { IReceitaBrutaNCMReceber } from '../../../../../../../../../interfaces/IReceitaBruta';
import { ETipoOperacao } from '../../../../../../../../../enums/ETipoOperacao';
import { IVendaNacionalNCMReceber } from '../../../../../../../../../interfaces/IVendaNacional';
import { INCMReceitaBrutaCalculada } from '../../../../../../../../../interfaces/IReceitaBrutaCalculada';
import {
  IReceitaExportacoesNCM,
  IReceitaExportacoesVinculadaNCM,
} from '../../../../../../../../../interfaces/IReceitaExportacoes';

interface IListaNCMProps {
  isReadOnly: boolean;
  listaNCMData:
    | IReceitaBrutaNCMReceber[]
    | IVendaNacionalNCMReceber[]
    | INCMReceitaBrutaCalculada[]
    | (IReceitaExportacoesNCM | IReceitaExportacoesVinculadaNCM)[]
    | undefined;
  refetchListaNCM: () => void;
  setIsEdicaoNcm?: React.Dispatch<React.SetStateAction<boolean>>;
  refetchDadosAnteriores?: () => void;
  type: ETipoOperacao;
}

const ListaNCM = ({
  isReadOnly,
  listaNCMData,
  refetchListaNCM,
  setIsEdicaoNcm,
  refetchDadosAnteriores,
  type,
}: IListaNCMProps) => {
  return (
    <div className={styles.container}>
      {!isReadOnly && <div className={styles.title}>Lista de NCMs adicionados</div>}
      {listaNCMData?.length === 0 && (
        <span className={styles.emptyText}>Não há NCMs adicionados. Adicione um NCM acima.</span>
      )}
      {listaNCMData?.map((ncm) => {
        return (
          <ListaNCMItem
            key={ncm?.id}
            ncm={ncm}
            isReadOnly={isReadOnly}
            refetchListaNCM={refetchListaNCM}
            setIsEdicaoNcm={setIsEdicaoNcm}
            refetchDadosAnteriores={refetchDadosAnteriores}
            type={type}
          />
        );
      })}
    </div>
  );
};

export default ListaNCM;
